<template>
  <div class="zhedang2" ref="zd" v-portal>
    <div class="baikuang2">
      <div class="title">
        <div class="closeBtn" @click="close"></div>
      </div>
      <div class="tktitle">{{ message }}</div>
      <div style="margin-top: 25px">
        <div @click="close" class="btn">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  props: {
    message: {
      default: "",
      type: String,
    },
  },
  directives: {
    portal: {
      inserted: function (el, binding) {
        var value = binding.value;
        var app = document.querySelector("#app");
        try {
          if (value) {
            typeof value == "string"
              ? document.querySelector(value).appendChild(el)
              : value.appendChild(el);
          } else app.appendChild(el);
        } catch (error) {
          console.log(error);
        }
      },
      unbind: function (el) {
        try {
          el.parentNode.removeChild(el);
        } catch (error) {
          console.log(error);
        }
      },
    },
  },
  methods: {
    close() {
      this.$emit("showbox", false);
    },
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     if (this.$refs.zd) {
  //       var zd = this.$refs.zd;
  //       var app = document.querySelector("#app");
  //       app.appendChild(zd);
  //     }
  //   });
  // },
  created() {

  },
};
</script>

<style scoped>
.zhedang2 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 33333 !important;
}
.baikuang2 {
  background: white;
  min-height: 160px;
  width: 373px;
  position: fixed;
  top: 20%;
  left: 40%;
  text-align: center;

  font-size: 15px;
}

.close {
  width: 6px !important;
  font-size: 12px;
  text-align: right !important;
  position: absolute;
  right: 10px;
  top: -6px;
  cursor: pointer;
}
.tktitle {
  height: 30px;
  line-height: 30px;
  margin-top: 25px;
  font-weight: bold;
}
.btn {
  color: white;
  background: rgb(73, 132, 212);
  height: 30px;
  line-height: 30px;
  width: 96px;
  margin: 0 auto;
  cursor: pointer;
}
.closeBtn {
  width: 35px;
  height: 30px;
  position: absolute;
  right: 0;
  top: 0;
  background: url(../assets/img/close.png) no-repeat center;
  background-size: 12px;
  cursor: pointer;
}
.title {
  height: 30px;
  background: url(../assets/img/confirm_title_bg.jpg) no-repeat;
  color: #fafafa;
  font-size: 15px;
  line-height: 34px;
  padding-left: 11px;
  position: relative;
}
</style>